import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "@/axios";
import store from "./store";

import Modernizr from "modernizr";

import SlideUpDown from "vue-slide-up-down";
import AppImage from "./components/AppImage";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

import "./bootstrap/fontAwesome";
import "./bootstrap/veeValidate";

import "./assets/styles/index.css";
import "./assets/css/style.css";
import "./assets/styles/fonts.css";

import "./utils.js";
// import moment from "moment";
import VueCookies from "vue-cookies";
import VueGtm from "vue-gtm";
const biri = require("biri");

console.log("STORE", store.state._ga);

if (!store.state._ga || store.state._ga === "") {
    biri()
        .then(ga => {
            store.dispatch("SAVE_GA", ga);
        })
        .catch(() => {
            let ga = VueCookies.get("_ga");
            if (!ga) {
                ga = VueCookies.get("__utma");
            }
            if (!ga) {
                const uint32 = window.crypto.getRandomValues(
                    new Uint32Array(1)
                )[0];
                ga = uint32.toString(16);
            }

            store.dispatch("SAVE_GA", ga);
        });
}

Vue.use(VueGtm, {
    id: "GTM-5WXLPPN", // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
    defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    // ignoredViews: ["homepage"], // Don't trigger events for specified router names (case insensitive) (optional)
    trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
});

Vue.use(VueCookies);

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.config.productionTip = false;

Vue.component("slide-up-down", SlideUpDown);
Vue.component("app-image", AppImage);

Vue.prototype.$config = store.getters.getConfigValue;

Vue.prototype.$isMobile = () => {
    if (typeof navigator === "undefined") return false; // SSR guard

    const patterns = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];
    return patterns.some(r => r.test(navigator.userAgent));
};
// import VueVideoPlayer from "vue-video-player";
// Vue.use(VueVideoPlayer);

Vue.use(VueSweetalert2, {
    customClass: {
        popup: "border-2 border-solid border-orange",
        title: "font-primary text-4xl text-blue",
        content: "font-secondary"
    }
});

Modernizr.on("webp", function(result) {
    Vue.prototype.$supportsWebp = result;

    new Vue({
        beforeCreate() {},
        updated() {
            // console.log("GA VUE up",ga);
            // this.$store.dispatch("SAVE_GA", ga);
        },
        router,
        store,
        render: h => h(App)
    }).$mount("#app");
});
